import type { ElementType } from 'react'
import { Layers, Package, Wrench } from 'lucide-react'
import type { PropostaItemTipo } from '@/types'

export interface AvailableItem {
  id: string
  nome: string
  descricao?: string
  valor: number
  tipo: PropostaItemTipo
  recorrente: boolean
  config?: Record<string, unknown>
  category?: string
}

export const tipoConfig: Record<
  PropostaItemTipo,
  { label: string; icon: ElementType; color: string }
> = {
  plano: { label: 'Plano', icon: Layers, color: '#40C351' },
  servico: { label: 'Serviço', icon: Wrench, color: '#2563EB' },
  avulso: { label: 'Avulso', icon: Package, color: '#E35933' },
}

export function generateStudioItemId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}
